// ============================================================================
// CHARGE TYPE SERVICE
// ============================================================================
// Read-only lookup service for charge types.
// The backend returns a flat list (NOT PagedResult) wrapped in ApiResponse.

import { get } from '../client/axiosClient';
import { chargeTypeEndpoints } from '../endpoints/chargeType.endpoints';
import type { ApiResponse, ChargeType } from '../types';

class ChargeTypeService {
  /**
   * Get all charge types. Returns a flat array (small lookup — 4 rows).
   * The backend wraps the list in ApiResponse<List<ChargeTypeDto>>.
   */
  async getAll(): Promise<ApiResponse<ChargeType[]>> {
    const response = await get<any>(chargeTypeEndpoints.list());
    const raw = response.data;
    return {
      success: raw?.success ?? false,
      message: raw?.message,
      data: raw?.data ?? [],
    };
  }

  async getById(id: string): Promise<ApiResponse<ChargeType>> {
    const response = await get<ApiResponse<ChargeType>>(
      chargeTypeEndpoints.getById(id)
    );
    return response.data;
  }

  async getByCode(code: string): Promise<ApiResponse<ChargeType>> {
    const response = await get<ApiResponse<ChargeType>>(
      chargeTypeEndpoints.getByCode(code)
    );
    return response.data;
  }
}

export const chargeTypeService = new ChargeTypeService();
export default chargeTypeService;
